export default __webpack_public_path__ + "static/media/locationMapIcon.ea6eb665.svg";